import React from 'react'
import { useParams } from 'react-router-dom'
import ResourceAllocationForm from './ResourceAllocationForm'

const ResourceAllocationView = () => {
  const { id } = useParams()
  
  return <ResourceAllocationForm mode="view" allocationId={id} />
}

export default ResourceAllocationView

